module.exports = __webpack_public_path__ + "static/img/03.1009c05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour1/03.jpg
// module id = +V2E
// module chunks = 0